



























import mixins from 'vue-typed-mixins';
import WorksheetUtils, {
  Worksheet,
  WorksheetResult,
} from '@/utils/WorksheetUtils';
import WorksheetItem from './WorksheetItem.vue';
import cloneDeep from 'lodash.clonedeep';
export default mixins().extend({
  components: {
    WorksheetItem,
  },

  computed: {
    id(): number {
      const id = parseInt(this.$route.params.worksheet);
      return id;
    },

    headers(): any {
      return [
        {
          text: this.$tc('model.serviceProvider.label'),
          value: 'participation.serviceprovider.name',
        },
        ...(this.worksheet?.layout.headers || []).map((header, index) => ({
          text: this.$translate(header.name),
          value: header?.question?.key,
          sortable: false,
          filterable: false,
        })),
      ];
    },
  },

  data(): {
    worksheet?: Worksheet;
    items?: WorksheetResult[];
    item?: WorksheetResult;
  } {
    return {
      worksheet: undefined,
      items: undefined,
      item: undefined,
    };
  },

  async mounted() {
    this.loadWorksheet();
    this.loadWorksheetResults();
  },

  watch: {
    '$i18n.locale'() {
      this.loadWorksheetResults(); // reload when language changes
    },
  },

  methods: {
    async loadWorksheet() {
      try {
        this.$alert.hide('loadWorksheet');
        this.worksheet = undefined;
        this.worksheet = await WorksheetUtils.api.get(this.id);
      } catch (error) {
        this.$alert.show('loadWorksheet', {
          type: 'error',
          messages: this.$handleAPIError(error),
        });
      }
    },

    async loadWorksheetResults() {
      try {
        this.$alert.hide('loadWorksheetResults');
        this.items = undefined;
        this.item = undefined;
        this.items = await WorksheetUtils.api.view(this.id);
      } catch (error) {
        this.$alert.show('loadWorksheetResults', {
          type: 'error',
          messages: this.$handleAPIError(error),
        });
      }
    },

    edit(item: WorksheetResult) {
      this.item = cloneDeep(item);
    },
  },
});
